'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ConfirmationEmailByUrlParamsProcessor = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _class, _temp;

var _user = require('redux/actions/user');

var _auth = require('redux/actions/auth');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ConfirmationEmailByUrlParamsProcessor = exports.ConfirmationEmailByUrlParamsProcessor = (_temp = _class = function () {
    function ConfirmationEmailByUrlParamsProcessor(location, params, store) {
        (0, _classCallCheck3.default)(this, ConfirmationEmailByUrlParamsProcessor);
        this.confirmationKey = null;
        this.orderId = null;

        this.location = location;
        this.store = store;
        this.params = params;
    }

    (0, _createClass3.default)(ConfirmationEmailByUrlParamsProcessor, [{
        key: 'tryToConfirm',
        value: function tryToConfirm() {
            var _this = this;

            this.retriveParams();
            if (this.confirmationKey === null || this.isEmailAlredyConfirmed()) {
                return _promise2.default.resolve(true);
            }
            var state = this.store.getState();
            if (!state.auth.user) {
                return _promise2.default.resolve(false);
            }
            if (this.store && typeof this.store.dispatch === 'function') {
                return this.store.dispatch((0, _user.confirmEMailBySignature)(this.orderId, this.confirmationKey)).then(function () {
                    return _this.store.dispatch((0, _auth.load)());
                }).then(function () {
                    return _this.isEmailAlredyConfirmed();
                });
            }

            return _promise2.default.resolve(false);
        }
    }, {
        key: 'isEmailAlredyConfirmed',
        value: function isEmailAlredyConfirmed() {
            if (this.store && typeof this.store.getState === 'function') {
                var state = this.store.getState();
                if (state.auth && state.auth.user && state.auth.user.confirmed) {
                    var confirmations = state.auth.user.confirmed;
                    return !!confirmations.confirmed_email;
                }
            }
            return false;
        }
    }, {
        key: 'retriveParams',
        value: function retriveParams() {
            var keyInQuery = ConfirmationEmailByUrlParamsProcessor.CONFIRMATION_KEY_NAME_IN_URL;
            var orderIdInParams = ConfirmationEmailByUrlParamsProcessor.CONFIRMATION_ORDER_ID_IN_URL;

            if (this.location && this.location.query != null) {
                if (Object.hasOwnProperty.call(this.location.query, keyInQuery)) {
                    if (typeof (this.confirmationKey = this.location.query[keyInQuery]) === 'string') {
                        if (!this.confirmationKey.length) {
                            this.confirmationKey = null;
                        }
                    }
                }
            }

            if (this.params && Object.hasOwnProperty.call(this.params, orderIdInParams)) {
                this.orderId = this.params[orderIdInParams];
            }
        }
    }]);
    return ConfirmationEmailByUrlParamsProcessor;
}(), _class.CONFIRMATION_KEY_NAME_IN_URL = 'confirm_signature', _class.CONFIRMATION_ORDER_ID_IN_URL = 'order_id', _temp);


//////////////////
// WEBPACK FOOTER
// ./src/helpers/confirmation.js
// module id = 1859
// module chunks = 0